import { html } from 'lit';
import { sectionHeading } from '../components/sectionHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const infoSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    id="informationen"
    class=${editorNodeClass(editor, 'section.info', 'vp-section vp-info-section')}
    style=${editorNodeStyle(editor, 'section.info')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.info', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.info', event)}
  >
    <div class="vp-shell">
      ${sectionHeading({
        eyebrow: content.info.eyebrow,
        title: content.info.title,
        highlight: content.info.titleHighlight,
        align: 'center',
        editor,
        elementPrefix: 'info',
      })}
      <div
        class=${editorNodeClass(editor, 'info.links.container', 'vp-resource-list')}
        style=${editorNodeStyle(editor, 'info.links.container')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'info.links.container', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'info.links.container', event)}
      >
        ${content.info.links.map(
          (link, index) => html`
            <a
              href=${link.href}
              target="_blank"
              rel="noopener noreferrer"
              @click=${(event: MouseEvent) => {
                if (editor?.mode === 'editor') event.preventDefault();
              }}
            >
              <span
                class=${editorNodeClass(editor, `info.link.${index}.label`)}
                style=${editorNodeStyle(editor, `info.link.${index}.label`)}
                @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `info.link.${index}.label`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `info.link.${index}.label`, event)}
                >${link.label}</span
              >
              <span class="icon-[material-symbols--open-in-new]"></span>
            </a>
          `,
        )}
      </div>
    </div>
  </section>
`;
